export const FETCH_HOLDTEAM_REQUEST = 'FETCH_HOLDTEAM_REQUEST';
export const FETCH_HOLDTEAM_SUCCESS = 'FETCH_HOLDTEAM_SUCCESS';
export const FETCH_HOLDTEAM_ERROR   = 'FETCH_HOLDTEAM_ERROR';

export const REASSIGN_HOLDTEAM_REQUEST = 'REASSIGN_HOLDTEAM_REQUEST';
export const REASSIGN_HOLDTEAM_SUCCESS = 'REASSIGN_HOLDTEAM_SUCCESS';
export const REASSIGN_HOLDTEAM_ERROR   = 'REASSIGN_HOLDTEAM_ERROR';
